// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"translate-1"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M5.02184 8.32617C6.42977 11.0549 8.5996 13.3267 11.25 14.8598M7.5 5.5V3M7.5 5.5H12M7.5 5.5H3M3.5 14.8594C6.87215 12.9081 9.46658 9.7616 10.7031 6","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M21 21L16.5 11.5L12 21M19.55 19H13.45","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Translate1Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'translate-1',
    ref,
    icon: element,
  },
));

Translate1Icon.displayName = 'Translate1Icon';

export default Translate1Icon;
